import React from "react";
import {FormFeedback,Label} from 'reactstrap';

const Input = ({id, name, input_type, description, placeholder, value, options, onChange, required, errors}) => {

    return (
        <div className="row mb-2">
            <div className="col-md-4 pr-md-1 align-self-center">
                <Label check>
                    {description} {!!required && '*'}
                </Label>
            </div>
            <div className="col-md-8">
                <div className="input-group">
                    {(options && options[0]?.prepend) && <div className="input-group-prepend">
                        <span className="input-group-text">{options[0].prepend}</span>
                    </div>}
                    <input type={input_type} name={name} value={value ?? ''}
                           className={`form-control ${!!errors ? ' is-invalid ' : ' '}`}
                           placeholder={placeholder || description}
                           onChange={(e) => {
                               onChange(id, {
                                   [e.target.name]: e.target.value
                               })
                           }}/>
                    {(options && options[0]?.append) && <div className="input-group-append">
                        <span className="input-group-text">{options[0].append}</span>
                    </div>}
                    {(options && options[0]?.description) && <small className="form-text text-muted w-100">
                        {options[0].description}
                    </small>}
                    {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
                </div>
            </div>
        </div>
    )
}
export default Input;
